import script from "./AdosBrief.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdosBrief.vue?vue&type=script&setup=true&lang=ts"

import "./AdosBrief.vue?vue&type=style&index=0&id=221891ed&scoped=true&lang=css"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221891ed"]])

export default __exports__